import React from 'react';
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotate } from '@fortawesome/free-solid-svg-icons';

export default () => {
  const {
    loading,
  } = useSelector((state) => state.fabrication)

  const clazz = classnames({
    'pcb-loading-overlay': true,
    hidden: !loading,
  })
  return (
    <div className={clazz}>
      <div className="spin">
        <FontAwesomeIcon icon={faRotate} spin />
      </div>
    </div>
  )
}